module.exports = "/img/_/_/_/assets/images//navigation_drawer_show.png?ff08eed2be8b0b1c1138991830a85f81";